import { render, staticRenderFns } from "./TableChamados.vue?vue&type=template&id=148b13ba&scoped=true&"
import script from "./TableChamados.vue?vue&type=script&lang=js&"
export * from "./TableChamados.vue?vue&type=script&lang=js&"
import style0 from "./TableChamados.vue?vue&type=style&index=0&id=148b13ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b13ba",
  null
  
)

export default component.exports